function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#3FA7D2",
  d: "M17.842 24.754l1.916-2.308 63.6 52.8-1.916 2.308z"
}), React.createElement("path", {
  fill: "#D92F31",
  d: "M80.406 76.156l-.812 2.888-38.4-10.8.812-2.888z"
}), React.createElement("path", {
  fill: "#92C459",
  d: "M35.732 60.11l-2.664 1.38-18-34.8 2.664-1.38z"
}), React.createElement("path", {
  fill: "#D92F31",
  d: "M90.8 80a4.8 4.8 0 1 0-9.6 0 4.8 4.8 0 0 0 9.6 0zm2.4 0a7.2 7.2 0 1 1-14.401-.001A7.2 7.2 0 0 1 93.2 80z"
}), React.createElement("path", {
  fill: "#92C459",
  d: "M41.6 65.6a4.8 4.8 0 1 0-9.601.001A4.8 4.8 0 0 0 41.6 65.6zm2.4 0a7.2 7.2 0 1 1-14.4 0 7.2 7.2 0 0 1 14.4 0z"
}), React.createElement("path", {
  fill: "#3FA7D2",
  d: "M18.8 20a4.8 4.8 0 1 0-9.6 0 4.8 4.8 0 0 0 9.6 0zm2.4 0a7.2 7.2 0 1 1-14.401-.001A7.2 7.2 0 0 1 21.2 20z"
}));

var SvgOnecLogo = function SvgOnecLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOnecLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onecLogo.79a69292.svg";
export { ForwardRef as ReactComponent };